import { usePopper } from '../../Popper/hooks';

export const usePopover = usePopper;
